import React from 'react'
import RewardLeaderboardPage from './RewardLeaderboardPage'

const RewardReferPage: React.FC = () => <RewardLeaderboardPage tab="refer" />

export default RewardReferPage
